import { useState, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { AxiosError } from 'axios';

import { AuthApi } from '../api';

export const useConfirmPasswordChange = (): {
  error: string | null;
  success: boolean;
  loading: boolean;
  handleConfirmPasswordChange: (values: { password: string }) => Promise<void>;
} => {
  const { search } = useLocation();
  const { otp, email } = useMemo(() => {
    const params = new URLSearchParams(search);
    return {
      otp: params.get('token') ?? '',
      email: params.get('email') ?? '',
    };
  }, [search]);

  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirmPasswordChange = useCallback(
    async ({ password }: { password: string }) => {
      try {
        setLoading(true);
        setError(null);
        await AuthApi.confirmPasswordChange({
          email,
          otp,
          newPassword: password,
        });
        setSuccess(true);
      } catch (err) {
        const errorMessage = (err as unknown as AxiosError<string>).response
          ?.data;
        setError(errorMessage ?? 'Something went wrong. Please try again.');
      } finally {
        setLoading(false);
      }
    },
    [email, otp],
  );

  return { error, success, loading, handleConfirmPasswordChange };
};
